import React, { Component, Fragment } from 'react';
import {
  AutoComplete,
  Button,
  Cascader,
  Form,
  Input,
  Modal,
  message,
  notification,
  Radio,
  Select,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { __ } from '@wordpress/i18n';
import qs from 'query-string';

import './styles.module.scss';
import styles from './contact-us.module.scss';
import AppHelper from 'libs/AppHelper';
import { API_HOST, LOGIN_LINK } from '../../configs/env';
import whttp from '../../libs/whttp';
import { genFormItemAtrribute } from 'libs/FormHelper';
import NavTab from 'components/NavTab/NavTab';
import queryOptionsProd from './queryOptions.json';
import queryTargetOptions from './queryTargetOptions.json';
import querySubjectOptions from './querySubjectOptions.json';
import retailChannelOptions from './retailChannelOptions.json';
import WUpload from 'components/WUpload/WUpload';

import ICON_PERSON from 'assets/img/contact/1_person.svg';
import ICON_INFO from 'assets/img/contact/2_info.svg';
import ICON_MESSAGE from 'assets/img/contact/3_message.svg';
import ICON_PLACE from 'assets/img/contact/4_place.svg';
import ICON_REPLY from 'assets/img/contact/5_reply.svg';
import ICON_FILE from 'assets/img/contact/6_file.svg';

const queryOptions = queryOptionsProd;

const fileType =
  '.png,.jpg,.jpeg,.bmp,.avi,.mp4,.mp3,.mkv,.3gp,.mov,image/png,image/jpeg,image/bmp,image/x-windows-bmp,application/x-troff-msvideo,video/avi,video/msvideo,video/x-msvideo,audio/mpeg3,audio/x-mpeg-3,video/mpeg,video/x-mpeg,video/quicktime,video/mp4,video/mkv';

const VC_CONFIG = _.get(window, 'VC_CONFIG', {});
const ONLINE_SHOPPING_CODES = ['online_shopping', 65, 70, 71];

const SubjectID = {
  CustomerService: 1, //客服建議
  NewProduct: 2, //新品推薦
  OutOfStock: 3, //缺貨回報
  Expensive: 4, //買貴回報
  Service: 5, //服務建議
};

export default class ContactUs extends Component {
  formRef = React.createRef();

  state = {
    tabType: 'info',
    info: {},
    option: [],
    files: [],
    query: {
      OrderId: null,
      Name: null,
      Tel: null,
      Email: null,
      ProductId: null,
      Type: null,
    },
    orderOptions: [],
    isSubmitData: false,
    visible: false,
    confirmLoading: false,
    data: {},
    isShowChannelStoresField: false,
    configs: {},
    allStores: [],
    isFileUploading: false,
    agreePersonalInfo: false,
    personalInfoScrolledToBottom: false, // 新增狀態
  };

  componentDidMount() {
    this.setState({
      tabType: AppHelper.getHashValue('tab') || 'info',
    });
    this.fetchConfigs();
    this.fetchStores();
    this.fillData();
    if (window.location.href.indexOf('?data') != -1) {
      const filldata = JSON.parse(AppHelper.getURLQuery().data);
      this.formRef.current.setFieldsValue(filldata);
    }
    this.loadOrderList();
  }

  fillData = (data = {}) => {
    this.formRef.current.setFieldsValue({
      Var_QueryPeo: null, // queryTargets.0
      Var_QueryStore: null,
      Var_ChannelStore: null,
      Var_Place: null,
      Var_QueryType: null,
      Var_Type: null,
      Var_Product: null,
      Var_Name: null,
      Var_Subject: null,
      Var_Email: null,
      Var_Tel: null,
      Txt_Memo: null,
      Var_Source: 1,
      Var_OrderId: undefined,
      Var_ProductId: null,
      Var_Files: [],
      querySubject: 1,
      queryTypes: [],
      queryTargets: [],
    });
  };

  fetchConfigs = () => {
    whttp.get(API_HOST + '/api/v1/system/configs', null, (state, res) => {
      const { code = 100, reason = '發生錯誤', data = {} } = res;
      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }
      if (code !== 200) {
        return this.setState({ message: reason });
      }
      this.setState({ configs: data.options });
    });
  };

  fetchStores = () => {
    whttp.get(
      API_HOST + '/api/v1/stores',
      { page_size: 'all' },
      (state, res) => {
        const { code = 100, reason = '發生錯誤', data = {} } = res;
        if (state === false) {
          return this.setState({ message: '發生錯誤' });
        }
        if (code !== 200) {
          return this.setState({ message: reason });
        }
        this.setState({ allStores: data.rows });
      }
    );
  };

  loadOrderList = () => {
    const isLogin = _.get(this, 'props.auth.isLogin');
    if (!isLogin) return;
    this.setState({ isLoadOrderList: true });
    whttp.get(API_HOST + '/api/account/getOrderList', {}, (state, res) => {
      this.setState({ isLoadOrderList: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }
      if (code !== 200) {
        return this.setState({ message: reason });
      }

      const orderOptions = _.map(data, (item) => ({
        code: item.code,
        order_date: item.order_date,
        store_name: item.store_name,
      }));
      this.setState({ orderOptions });
    });
  };

  selectStoreCode = (storeCode) => {
    _.forEach(queryTargetOptions, (target) => {
      _.forEach(target.items, (targetSubItem) => {
        if (targetSubItem.UnitCode === storeCode) {
          this.formRef.current.setFields([
            {
              name: ['queryTargets'],
              value: [target.id, targetSubItem.id],
              touched: true,
              validating: false,
              errors: [],
            },
          ]);
        }
      });
    });
  };

  copyString = (text) => {
    var input = document.createElement('textarea');
    input.setAttribute('type', 'text');
    input.value = text;
    document.getElementsByTagName('body')[0].appendChild(input);
    input.select();
    document.execCommand('copy');
    input.remove();
  };

  submitData = (info = {}) => {
    const queryTypes = [
      info.queryTypes_lv1,
      info.queryTypes_lv2,
      info.queryTypes_lv3,
    ];
    const subject1st = parseInt(_.get(info, 'querySubject'), 10);
    const type1st = parseInt(queryTypes[0], 10);
    const type2nd = parseInt(queryTypes[1], 10);
    const type3rd = parseInt(queryTypes[2], 10);
    const target1st = parseInt(_.get(info, 'queryTargets.0'), 10);
    const target2nd = parseInt(_.get(info, 'queryTargets.1'), 10);
    const target3rd = parseInt(_.get(info, 'queryTargets.2'), 10);
    const channel1st = '';
    const channel2nd = '';
    const channel3rd = '';
    const channel4th = '';

    const files = [];
    this.formRef.current.getFieldValue('Var_Files').forEach((file) => {
      if (file.path) {
        files.push(file.path);
      }
    });

    info.Var_Files = files;
    info.Var_Subject = `${info.Var_Subject}`;
    info.Var_QueryType = type1st;
    info.Var_Type = type2nd;
    info.Var_QueryPeo = target1st;
    info.Var_QueryStore = !isNaN(target2nd) ? target2nd : '';
    info.Var_Channel_Store_Type = channel1st;
    info.Var_Channel_City = channel2nd;
    info.Var_Channel_Area = channel3rd;
    info.Var_Channel_Store_Name = channel4th;

    if (target1st === 28) {
      const channel1st = info['channelStores'][0];
      const channel2nd = info['channelStores'][1];
      const channel3rd = info['channelStores'][2];
      const channel4th = info['channelStores'][3];

      const allStores = _.get(this.state, 'allStores');
      const scs_number = allStores
        .filter((item) => item.name === channel4th)
        .map((scs) => scs.scs_number)
        .toString();
      const scs_number_id = allStores
        .filter((item) => item.name === channel4th)
        .map((scs) => scs.scs_number_id)
        .toString();

      info.Var_Channel_Store_Type = channel1st;
      info.Var_Channel_City = channel2nd;
      info.Var_Channel_Area = channel3rd;
      info.Var_Channel_Store_Name = channel4th;
      info.Var_QueryPeo = scs_number_id;
      info.Var_QueryStore = scs_number;
    }

    if (info.Var_OrderId && !_.isEmpty(info.Var_OrderId)) {
      info.Txt_Memo += `\n訂單編號：${info.Var_OrderId}`;
    }
    // 客服建議、服務建議
    if ([SubjectID.CustomerService, SubjectID.Service].includes(subject1st)) {
      if (
        subject1st === SubjectID.CustomerService && // 客服建議
        [15, 16, 31].includes(type2nd) // 產品查詢/建議Product Inquiry/Suggestion、欲成為合作廠商來信Supplier Inquiry、產品品質/價格相關問題Product Quality
      ) {
        info.Var_Product = type3rd;
      }
      if (subject1st === SubjectID.Service && [31].includes(type1st)) {
        // 服務建議
        info.Var_Product = type2nd;
      }
      if (subject1st === SubjectID.Service) {
        info.Var_QueryType = 2;
      }
    }
    // 新品推薦、缺貨回報、買貴回報
    else {
      info.Var_QueryPeo = target1st;
      info.Var_QueryStore = '';
      info.Var_Product = type3rd;
      info.Var_Type = type2nd;
      info.Var_QueryType = '';
    }
    // 新品推薦
    if (subject1st === SubjectID.NewProduct) {
      //固定為總公司回覆
      info.Var_QueryPeo = 2;
      info.Var_QueryStore = '';
      info.Var_QueryType = 1;
      info.Var_Type = 15;
      info.Var_Subject = `新品推薦 : ${info.product_name}`;
      info.Txt_Memo = [
        '[ 新品推薦 ]',
        `資訊來源 : [${info.data_source}]`,
        `商品條碼 : ${info.product_barcode}`,
        `通路售價 : ${info.product_price}`,
        `供應商 : ${info.supplier}`,
        `推薦商品資訊 : ${info.product_info}`,
      ].join('\n');
      delete info.product_name;
      delete info.data_source;
      delete info.product_barcode;
      delete info.product_price;
      delete info.supplier;
      delete info.product_info;
    }
    // 缺貨回報
    if (subject1st === SubjectID.OutOfStock) {
      //固定為總公司回覆
      info.Var_QueryPeo = 2;
      info.Var_Type = 31;
      info.Var_QueryType = 2;
      info.Txt_Memo = '[ 缺貨回報 ] ' + info.Txt_Memo;
    }
    // 買貴回報
    if (subject1st === SubjectID.Expensive) {
      //固定為總公司回覆
      info.Var_QueryPeo = 2;
      info.Var_QueryType = 2;
      info.Var_Type = 31;
      info.Var_Subject = `買貴回報 : ${info.product_name}`;
      info.Txt_Memo = [
        '[ 買貴回報 ]',
        `是否為促銷：[${info.onsale}]`,
        `通路類型 : ${_.get(info, 'retailChannel.0')}`,
        `比價通路 : ${_.get(info, 'retailChannel.1')}`,
        `比價通路售價 : ${info.product_price}`,
        `留言內容：${info.desc}`,
      ].join('\n');
    }
    delete info.querySubject;
    delete info.queryTargets;
    delete info.channelStores;
    delete info.queryTypes_lv1;
    delete info.queryTypes_lv2;
    delete info.queryTypes_lv3;

    setTimeout(() => {
      AppHelper.removeLocalStorage('contact-data');
      AppHelper.removeLocalStorage('to-href');

      const xml = _.map(info, (v, k) => `<${k}>${v}</${k}>`).join('\n');
      this.copyString(xml);
      this.setState({ isSubmitData: true, messages: {} });
      whttp.post(API_HOST + `/api/contactus/custAdvice`, info, (state, res) => {
        this.setState({
          isSubmitData: false,
          confirmLoading: false,
          visible: false,
        });

        const { code = 100, reason = '發生錯誤', data = {} } = res;

        if (state === false) {
          return message.error('發生錯誤');
        }

        if (code !== 200) {
          notification['error']({
            message: '發生錯誤',
            description: reason,
          });

          return this.setState({ messages: data.messages || {} });
        }
        Modal.success({
          content: '送出成功!',
          onOk: () => {
            window.location.href = VC_CONFIG.INDEX_URL;
          },
        });
      });
    }, 1000);
  };

  checkSending = () => {
    this.setState({ visible: true });
  };

  // ALVIN 2023/05/05 調整為CC登入
  GetCCUri = () => {
    this.setState({ isSubmitData: true });
    whttp.get(API_HOST + `/api/account/cc/login`, {}, (state, res) => {
      console.log(state, res);

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res;

      if (state === false) {
        this.setState({ isSubmitData: false });
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL;
          },
        });
      }

      if (code !== 200) {
        this.setState({ isSubmitData: false });
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL;
          },
        });
        return;
      }
      console.log(code, reason, data, res);
      // 改為前往CC登入頁面
      // this.GoCCLoginPage(data.uri)
      this.setState({ isSubmitData: false });
      this.setState({ LoginUrl: data.uri });
      window.location.href = data.uri;
    });
  };

  // 2023/05/05 取得並前往 CC Login Url
  GoCCLoginPage = (ccApiUrl) => {
    whttp.get(ccApiUrl, {}, (state, res) => {
      console.log(state, res);
      this.setState({ isSubmitData: false });

      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res;
      if (state === false) {
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL;
          },
        });
      }
      if (code !== 200) {
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL;
          },
        });
        return;
      }
      console.log(code, reason, data, res);
      this.setState({ LoginUrl: data.uri });
      window.location.href = data.uri;
    });
  };

  GetOcaUri = () => {
    this.setState({ isSubmitData: true });
    whttp.get(API_HOST + `/api/account/oca/login`, {}, (state, res) => {
      this.setState({ isSubmitData: false });
      const {
        code = 100,
        reason = __('發生錯誤', 'cec-plugin-stores'),
        data = {},
      } = res;

      if (state === false) {
        return notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL;
          },
        });
      }
      if (code !== 200) {
        notification['error']({
          message: __(
            '登入頁面讀取失敗，請稍候再試。',
            'cec-plugin-stores'
          ),
          description: reason,
          onClose: () => {
            window.location.href = VC_CONFIG.INDEX_URL;
          },
        });
        return;
      }
      this.setState({ LoginUrl: data.uri });
      window.location.href = data.uri;
    });
  };

  getFieldValue = (key, defaultValue = undefined) => {
    return this.formRef.current
      ? this.formRef.current.getFieldValue(key)
      : defaultValue;
  };

  showInfo = _.debounce((info) => {
    Modal.destroyAll();
    Modal.info(info);
  }, 300);

  handleFormSubmit = (e) => {
    e.preventDefault();
    this.formRef.current.submit();
    this.UIlog();
  };

  handleQueryTargetsChange = (value, selectedOptions) => {
    const optionNameSelected =
      selectedOptions.length > 0 ? selectedOptions[0].name : '';
    if (optionNameSelected === '通路門市Store') {
      this.setState({ isShowChannelStoresField: true });
    } else {
      this.setState({ isShowChannelStoresField: false });
    }
  };

  handleorderlist = () => {
    const orderOptions = this.state.orderOptions;
    const Var_OrderId = this.getFieldValue('Var_OrderId');
    const orderStoreName = orderOptions
      .filter((item) => item.code === Var_OrderId)
      .map((item) => item.store_name)
      .toString();
    this.formRef.current.setFieldsValue({
      Var_Place: orderStoreName,
    });
    const allStores = _.get(this.state, 'allStores');
    const storeList = allStores
      .filter((store) => {
        return store['name'] === orderStoreName;
      })
      .map((item) => {
        return {
          name: item.name,
          type: item.store_type_name,
          city: item.city_name,
          area: item.area_name,
        };
      });
    switch (orderStoreName) {
      case '楊梅發貨中心':
        this.formRef.current.setFieldsValue({
          queryTargets: ['43'],
        });
        this.setState({ isShowChannelStoresField: false });
        break;
      case '':
        this.formRef.current.setFieldsValue({
          queryTargets: [],
        });
        this.setState({ isShowChannelStoresField: false });
        break;
      default:
        this.formRef.current.setFieldsValue({
          queryTargets: ['28'],
        });
        this.formRef.current.setFieldsValue({
          channelStores: [
            storeList[0].type,
            storeList[0].city,
            storeList[0].area,
            storeList[0].name,
          ],
        });

        this.setState({ isShowChannelStoresField: true });
        break;
    }
  };

  UIlog = () => {
    const browser = _.get(window, 'browser');
    const os = _.get(window.navigator, 'userAgent');
    const querySubject = this.getFieldValue('querySubject');
    const queryTypes = this.getFieldValue('queryTypes', []);
    const type = ['84', '85', '86', '87', '88'].includes(queryTypes[0]);
    if ((querySubject === 4) & !type) {
      whttp.post(
        API_HOST + `/api/v1/contactuslog`,
        {
          os: os,
          browser: browser,
        },
        (state, res) => {
          this.setState({ isSubmitData: false });
          const { code = 100, reason = '發生錯誤', data = {} } = res;

          if (state === false) {
            return message.error('發生錯誤');
          }

          if (code !== 200) {
            notification['error']({
              message: '發生錯誤',
              description: reason,
            });
            return this.setState({
              messages: data.messages || {},
            });
          }
        }
      );
    }
  };

  getFileExtension = (filename) => {
    return filename.slice(((filename.lastIndexOf('.') - 1) >>> 0) + 2);
  };

  handlePersonalInfoAgreeChange = (e) => {
    this.setState({ agreePersonalInfo: e.target.checked });
  };

  handlePersonalInfoScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 2) {
      // 容許2px誤差
      if (!this.state.personalInfoScrolledToBottom) {
        this.setState({ personalInfoScrolledToBottom: true });
      }
    }
  };

  render() {
    const { configs, allStores, personalInfoScrolledToBottom } = this.state;
    // 根據 state 動態產生 aria-live 訊息
    const personalInfoA11yMsg = personalInfoScrolledToBottom
      ? '您已閱讀完個人資料聲明，現在可以勾選同意。'
      : '請閱讀至最下方以啟用同意勾選。';
    const isLogin = _.get(this, 'props.auth.isLogin', false);
    const orderOptions = _.get(this.state, 'orderOptions');
    const VC_CONFIG = _.get(window, 'VC_CONFIG');
    const PLUGIN_ASSETS_URL = VC_CONFIG.PLUGIN_ASSETS_URL;
    const selectedSubject = _.find(
      querySubjectOptions,
      (item) => item.id == this.getFieldValue('querySubject')
    );
    const subjectTitle = _.get(selectedSubject, 'name', '客服建議');
    const selectedSubjectId = _.get(selectedSubject, 'id');
    var pathname = window.location.pathname;
    if (pathname[0] == '/') {
      pathname = pathname.substr(1);
    }
    const isKiosk =
      pathname === 'kiosk/contact_us.html' ||
      _.get(qs.parse(window.location.search), 'view') === 'kiosk';
    const Locale = _.get(window, 'VC_CONFIG.Locale');
    var alldata = {};
    const storeTypes = configs['contact_store_type'] || [];

    const channelStoresList = storeTypes.map((type) => {
      const cities = configs['citys'].map((city) => {
        const areas = city.children.map((area) => {
          const storeList = allStores
            .filter((store) => {
              return (
                store['store_type_name'] === type.name &&
                store['city_name'] === city.name &&
                store['area_name'] === area.name
              );
            })
            .map((item) => {
              return {
                id: item.id,
                name: item.name,
                scs_number: item.scs_number,
                item: null,
                ShowStoreMenu: false,
              };
            });
          return {
            id: area.id,
            name: area.name,
            items: storeList,
            ShowStoreMenu: true,
            disabled: storeList.length === 0,
          };
        });
        return {
          id: city.id,
          name: city.name,
          items: areas,
          ShowStoreMenu: true,
        };
      });
      return {
        id: type.id,
        name: type.name,
        items: cities,
        ShowStoreMenu: true,
      };
    });

    const submitBtnCx =
      'h6 btn btn-block bg-white text-navy rounded-pill px-5 py-4';
    const submitBtnDisabledCx =
      'h6 btn btn-block bg-secondary text-navy rounded-pill px-5 py-4 disabled';

    // 訊息類別下拉選單
    const selectedQueryOption = queryOptions.find(
      (o) => o.id === selectedSubjectId
    );
    const queryTypesList_lv1 = selectedQueryOption
      ? selectedQueryOption.items
      : [];
    const selectedQueryTypesLv1 = queryTypesList_lv1.find(
      (o) => o.id === this.formRef.current.getFieldValue('queryTypes_lv1')
    );
    const queryTypesList_lv2 = selectedQueryTypesLv1
      ? selectedQueryTypesLv1.items
      : [];
    const selectedQueryTypesLv2 = queryTypesList_lv2.find(
      (o) => o.id === this.formRef.current.getFieldValue('queryTypes_lv2')
    );
    const queryTypesList_lv3 = selectedQueryTypesLv2
      ? selectedQueryTypesLv2.items
      : [];

    return (
      <Fragment>
        <main class='bg-light'>
          <Form
            noStyle
            ref={this.formRef}
            name='basic'
            className={styles['basic']}
            layout='vertical'
            autoComplete='off'
            onFinish={(values) => {
              this.checkSending(values)
              this.setState({ info: values })
            }}
            onFieldsChange={(changedFields, allFields) => {
              alldata = _.reduce(
                allFields,
                (r, i) => {
                  r[i.name.join('.')] = i.value
                  return r
                },
                {},
              )
              this.setState({ data: JSON.stringify(alldata) })
              localStorage.setItem('to-href', '/contact-us')
              localStorage.setItem('contact-data', this.state.data)
            }}>
            <section>
              <Form.Item
                noStyle
                {...genFormItemAtrribute('querySubject')}
                rules={[{ required: true, message: '請選擇詢問主題' }]}>
                <NavTab
                  value={this.getFieldValue('querySubject')}
                  tabs={_.map(
                    querySubjectOptions.filter((item) => item.id !== 5),
                    (item) => ({
                      value: item.id,
                      name: Locale == 'en_US' ? item.en_name : item.name,
                    }),
                  )}
                  onChange={(value, tabInfo) => {
                    this.option = _.get(
                      _.find(queryOptions, function(o) {
                        return o.id == value
                      }),
                      'items',
                    )
                    this.formRef.current.setFields([
                      {
                        name: ['queryTypes'],
                        value: [],
                        touched: true,
                        validating: false,
                        errors: [],
                      },
                    ])
                    this.setState(this.option)
                  }}
                />
              </Form.Item>
              <div class='container'>
                {/* 客服建議 */}
                <div class='row no-gutters mx-n3 mb-4 stre'>
                  <div class='col-lg-3 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body pb-0 pt-5 p-lg-5'>
                        <div class='row mb-4'>
                          <div class='col-4 mx-auto'>
                            <img
                              class='img-contain'
                              src={ICON_PERSON}
                              alt='客服建議'
                            />
                          </div>
                        </div>
                        <h5 class='h4 text-navy text-center'>
                          {Locale == 'en_US'
                            ? __(
                                _.get(
                                  _.find(
                                    querySubjectOptions,
                                    (item) =>
                                      item.id ==
                                      this.getFieldValue('querySubject'),
                                  ),
                                  'en_name',
                                  '客服建議',
                                ),
                                'cec-plugin-stores',
                              )
                            : __(
                                _.get(
                                  _.find(
                                    querySubjectOptions,
                                    (item) =>
                                      item.id ==
                                      this.getFieldValue('querySubject'),
                                  ),
                                  'name',
                                  '客服建議',
                                ),
                                'cec-plugin-stores',
                              )}
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div class='col-lg-9 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body p-5'>
                        <p class='h6 mb-0 text-navy'>
                          {__('親愛的顧客您好：', 'cec-plugin-stores')}
                          <br />
                          {__(
                            '若您對康達盛通有任何的建議或指教，我們非常歡迎您能來信指教，若您有急需反映之事項，請您致電 客服中心：0809-001-365、線上將有專人為您提供服務。 客服中心服務時間為早上9:00-晚上9:00，或您可透過語音直接轉由分店協助處理。感謝您。',
                            'cec-plugin-stores',
                          )}
                        </p>
                        {/* <p class="h6 mb-0 text-navy">
                          <p class="h6 mb-5">親愛的顧客您好：</p>
                          <p class="h6 mb-5">
                            新年快樂!!
                            <br />
                            農曆春節期間115年2月14日至2月22日期間，如您於賣場內購物有任何意見或反應，煩請您撥冗致電客服中心，將有專人為您服務。另外，您也可以於官方網站留下您的寶貴意見，我們將於115年2月23日上班日後儘快回覆您，造成您不便之處仍盼您諒解。
                          </p>
                          <p class="h6 mb-5">
                            客服中心
                            <br />
                            服務時間：09:00~21:00【除夕(2月16日：09:00~17:00)；初一(2月17日：10:00~21:00)】
                            <br />
                            服務電話：0809-001-365
                          </p>
                          <p class="h6">敬祝您有個美好的假期</p>
                        </p> */}
                        <div
                          className={styles['icon-call-wrapper']}
                          style={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            alignItems: 'flex-start',
                          }}>
                          <a
                            role='button'
                            target='_blank'
                            href='https://uni-prosperity.tototalk.com.tw/web-contact-us'
                            rel='noopener noreferrer'>
                            <img
                              style={{ maxWidth: 136 }}
                              alt=' '
                              src={`${PLUGIN_ASSETS_URL}img/contact/ICON-WB.png`}
                            />
                            <img
                              alt=' '
                              style={{ maxWidth: 150 }}
                              src={`${PLUGIN_ASSETS_URL}img/contact/web-contact-us.png`}
                            />
                          </a>
                          {/* 無障礙 aria-live 區塊 */}
                          <div
                            aria-live='polite'
                            aria-atomic='true'
                            style={{
                              position: 'absolute',
                              left: '-9999px',
                              height: '1px',
                              width: '1px',
                              overflow: 'hidden',
                            }}>
                            {personalInfoA11yMsg}
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}>
                            {/* 手機版個資告知區塊 */}
                            <div
                              className='d-block d-md-none'
                              style={{ width: '100%', marginTop: 16 }}>
                              <div
                                id='personalInfoStatement'
                                style={{
                                  border: '1px solid #ccc',
                                  borderRadius: 6,
                                  padding: 12,
                                  height: 120,
                                  overflowY: 'scroll',
                                  fontSize: 14,
                                  background: '#fff',
                                  marginBottom: 12,
                                  whiteSpace: 'pre-line',
                                }}
                                onScroll={this.handlePersonalInfoScroll}
                                ref={(el) =>
                                  (this.personalInfoBoxMobile = el)
                                }
                                tabIndex={0}
                                aria-label='個人資料蒐集告知及聲明內容'>
                                {__(
                                  '聯絡我們之《個人資料蒐集告知及聲明》\n\n就台端於「客服建議」、「新品推薦」、「缺貨回報」或「買貴回報」各表單所提出之申請，康達盛通生活事業股份有限公司(以下簡稱本公司)為處理台端之申請(包含查詢、通知、聯絡或回覆洽詢結果)、滿意度調查、表單資料處理(包含但不限於後續資料保存等相關事宜)之目的範圍內蒐集台端於所填表單所提供之各類個人資料（包括姓名、電話、地址、電子信箱、購物時間地點與識別類、特徵類、家庭情形、生活格調、社會情形、教育、受僱情形及其他所填表單所載個資類別等暨消費資訊及相關個人資料）。本公司得將個人資料於處理台端之申請(包含查詢、通知、聯絡或回覆洽詢結果)、滿意度調查、表單資料處理(包含但不限於後續資料保存等相關事宜)之目的範圍內，提供予本公司（含受本公司委託處理事務之機關）處理人員或該申請相關之廠商蒐集、處理或利用，使之協助處理台端之申請，並限於本公司所營業務存續期間(法律另有規定者則不在此限)，在中華民國境內及境外(包含但不限於日本)或「個人資料利用之對象」其國內及國外所在地以電子郵件、電話、簡訊、以自動化機器或其他非自動化之利用方式利用。\n\n台端得至www.uni-prosperity.com.tw網站留言或來電客服中心(電話：0809-001365，服務時間為每日上午9點至下午9點)主張個人資料保護法第三條規定之權利，請求查詢、閱覽、製給複製本、補充或更正、停止蒐集處理或利用、或刪除原提供之個人資料。另台端如請求查詢、閱覽個人資料或製給複製本時，將酌收必要成本費用。惟依法本公司因執行業務所必須者，本公司得不依台端請求為之。\n\n台端可自由選擇是否提供其個人資料，惟若拒絕提供相關個人資料，本公司將無法進行必要之處理作業，致無法完整提供相關服務。',
                                  'cec-plugin-stores',
                                )}
                              </div>
                              {!this.state.personalInfoScrolledToBottom && (
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    margin: '16px 0 20px 0',
                                  }}>
                                  <button
                                    type='button'
                                    style={{
                                      fontSize: 16,
                                      background: '#005BAC',
                                      color: '#fff',
                                      border: 'none',
                                      borderRadius: 6,
                                      padding: '10px 32px',
                                      cursor: 'pointer',
                                      boxShadow:
                                        '0 2px 8px rgba(0,0,0,0.06)',
                                      outline: 'none',
                                      transition:
                                        'box-shadow 0.2s, outline 0.2s',
                                    }}
                                    onClick={() => {
                                      // 完成後 scroll 到最下方
                                      if (this.personalInfoBoxMobile) {
                                        this.personalInfoBoxMobile.scrollTop = this.personalInfoBoxMobile.scrollHeight
                                      }
                                      this.setState({
                                        personalInfoScrolledToBottom: true,
                                      })
                                    }}
                                    aria-label='我已閱讀完畢'
                                    onFocus={(e) =>
                                      (e.target.style.boxShadow =
                                        '0 0 0 3px #90caf9')
                                    }
                                    onBlur={(e) =>
                                      (e.target.style.boxShadow =
                                        '0 2px 8px rgba(0,0,0,0.06)')
                                    }
                                    onMouseOver={(e) =>
                                      (e.target.style.background =
                                        '#003e7e')
                                    }
                                    onMouseOut={(e) =>
                                      (e.target.style.background =
                                        '#005BAC')
                                    }>
                                    {__(
                                      '我已閱讀完畢',
                                      'cec-plugin-stores',
                                    )}
                                  </button>
                                </div>
                              )}
                              <label
                                id='personalInfoCheckboxLabel'
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  fontSize: 14,
                                }}>
                                <input
                                  type='checkbox'
                                  checked={this.state.agreePersonalInfo}
                                  onChange={
                                    this.handlePersonalInfoAgreeChange
                                  }
                                  style={{ marginRight: 8 }}
                                  disabled={
                                    !this.state.personalInfoScrolledToBottom
                                  }
                                  aria-checked={
                                    this.state.agreePersonalInfo
                                      ? 'true'
                                      : 'false'
                                  }
                                  aria-disabled={
                                    !this.state.personalInfoScrolledToBottom
                                      ? 'true'
                                      : 'false'
                                  }
                                  aria-labelledby='personalInfoCheckboxLabel personalInfoStatement'
                                />
                                {__(
                                  '我已閱讀並同意 聯絡我們之《個人資料蒐集告知及聲明》',
                                  'cec-plugin-stores',
                                )}
                                {!this.state
                                  .personalInfoScrolledToBottom && (
                                  <span
                                    style={{
                                      color: '#888',
                                      marginLeft: 8,
                                      fontSize: 12,
                                    }}>
                                    {__(
                                      '請閱讀至最下方以啟用勾選',
                                      'cec-plugin-stores',
                                    )}
                                  </span>
                                )}
                              </label>
                            </div>
                          </div>
                          {/* 桌機版個資告知區塊 */}
                          <div
                            className='d-none d-md-flex'
                            style={{
                              flex: 1,
                              marginLeft: 24,
                              minWidth: 260,
                              maxWidth: 400,
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'stretch',
                            }}>
                            <div
                              id='personalInfoStatement'
                              style={{
                                border: '1px solid #ccc',
                                borderRadius: 6,
                                padding: 12,
                                height: 120,
                                overflowY: 'scroll',
                                fontSize: 14,
                                background: '#fff',
                                marginBottom: 12,
                                whiteSpace: 'pre-line',
                              }}
                              onScroll={this.handlePersonalInfoScroll}
                              ref={(el) => (this.personalInfoBox = el)}
                              tabIndex={0}
                              aria-label='個人資料蒐集告知及聲明內容'>
                              {__(
                                '聯絡我們之《個人資料蒐集告知及聲明》\n\n就台端於「客服建議」、「新品推薦」、「缺貨回報」或「買貴回報」各表單所提出之申請，康達盛通生活事業股份有限公司(以下簡稱本公司)為處理台端之申請(包含查詢、通知、聯絡或回覆洽詢結果)、滿意度調查、表單資料處理(包含但不限於後續資料保存等相關事宜)之目的範圍內蒐集台端於所填表單所提供之各類個人資料（包括姓名、電話、地址、電子信箱、購物時間地點與識別類、特徵類、家庭情形、生活格調、社會情形、教育、受僱情形及其他所填表單所載個資類別等暨消費資訊及相關個人資料）。本公司得將個人資料於處理台端之申請(包含查詢、通知、聯絡或回覆洽詢結果)、滿意度調查、表單資料處理(包含但不限於後續資料保存等相關事宜)之目的範圍內，提供予本公司（含受本公司委託處理事務之機關）處理人員或該申請相關之廠商蒐集、處理或利用，使之協助處理台端之申請，並限於本公司所營業務存續期間(法律另有規定者則不在此限)，在中華民國境內及境外(包含但不限於日本)或「個人資料利用之對象」其國內及國外所在地以電子郵件、電話、簡訊、以自動化機器或其他非自動化之利用方式利用。\n\n台端得至www.uni-prosperity.com.tw網站留言或來電客服中心(電話：0809-001365，服務時間為每日上午9點至下午9點)主張個人資料保護法第三條規定之權利，請求查詢、閱覽、製給複製本、補充或更正、停止蒐集處理或利用、或刪除原提供之個人資料。另台端如請求查詢、閱覽個人資料或製給複製本時，將酌收必要成本費用。惟依法本公司因執行業務所必須者，本公司得不依台端請求為之。\n\n台端可自由選擇是否提供其個人資料，惟若拒絕提供相關個人資料，本公司將無法進行必要之處理作業，致無法完整提供相關服務。',
                                'cec-plugin-stores',
                              )}
                            </div>
                            {!this.state.personalInfoScrolledToBottom && (
                              <div
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  margin: '16px 0 20px 0',
                                }}>
                                <button
                                  type='button'
                                  style={{
                                    fontSize: 16,
                                    background: '#005BAC',
                                    color: '#fff',
                                    border: 'none',
                                    borderRadius: 6,
                                    padding: '10px 32px',
                                    cursor: 'pointer',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                    outline: 'none',
                                    transition:
                                      'box-shadow 0.2s, outline 0.2s',
                                  }}
                                  onClick={() => {
                                    // 完成後 scroll 到最下方
                                    if (this.personalInfoBox) {
                                      this.personalInfoBox.scrollTop = this.personalInfoBox.scrollHeight
                                    }
                                    this.setState({
                                      personalInfoScrolledToBottom: true,
                                    })
                                  }}
                                  aria-label='我已閱讀完畢'
                                  onFocus={(e) =>
                                    (e.target.style.boxShadow =
                                      '0 0 0 3px #90caf9')
                                  }
                                  onBlur={(e) =>
                                    (e.target.style.boxShadow =
                                      '0 2px 8px rgba(0,0,0,0.06)')
                                  }
                                  onMouseOver={(e) =>
                                    (e.target.style.background = '#003e7e')
                                  }
                                  onMouseOut={(e) =>
                                    (e.target.style.background = '#005BAC')
                                  }>
                                  {__('我已閱讀完畢', 'cec-plugin-stores')}
                                </button>
                              </div>
                            )}
                            <label
                              id='personalInfoCheckboxLabel'
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                fontSize: 14,
                              }}>
                              <input
                                type='checkbox'
                                checked={this.state.agreePersonalInfo}
                                onChange={
                                  this.handlePersonalInfoAgreeChange
                                }
                                style={{ marginRight: 8 }}
                                disabled={
                                  !this.state.personalInfoScrolledToBottom
                                }
                                aria-checked={
                                  this.state.agreePersonalInfo
                                    ? 'true'
                                    : 'false'
                                }
                                aria-disabled={
                                  !this.state.personalInfoScrolledToBottom
                                    ? 'true'
                                    : 'false'
                                }
                                aria-labelledby='personalInfoCheckboxLabel personalInfoStatement'
                              />
                              {__(
                                '我已閱讀並同意 聯絡我們之《個人資料蒐集告知及聲明》',
                                'cec-plugin-stores',
                              )}
                              {!this.state.personalInfoScrolledToBottom && (
                                <span
                                  style={{
                                    color: '#888',
                                    marginLeft: 8,
                                    fontSize: 12,
                                  }}>
                                  {__(
                                    '請閱讀至最下方以啟用勾選',
                                    'cec-plugin-stores',
                                  )}
                                </span>
                              )}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 聯絡資訊 */}
                <div class='row no-gutters mx-n3 mb-4 stre'>
                  <div class='col-lg-3 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body pb-0 pt-5 p-lg-5'>
                        <div class='row mb-4'>
                          <div class='col-4 mx-auto'>
                            <img
                              class='img-contain'
                              src={ICON_INFO}
                              alt='聯絡資訊'
                            />
                          </div>
                        </div>
                        <h5 class='h4 text-navy text-center'>
                          {__('聯絡資訊', 'cec-plugin-stores')}
                        </h5>
                        <p class='note text-primary text-center mb-0'>
                          {__('必填資料', 'cec-plugin-stores')}*
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class='col-lg-9 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body p-5'>
                        <div class='row mb-4'>
                          <div class='col-md-6'>
                            <div class='form-group row align-items-center'>
                              <label
                                class='col-sm-4 col-form-label h6 text-navy'
                                for=''>
                                {__('姓名', 'cec-plugin-stores')}*
                              </label>
                              <div class='col-sm-8'>
                                <Form.Item
                                  {...genFormItemAtrribute('Var_Name')}
                                  className='mb-0'
                                  rules={[
                                    {
                                      type: 'string',
                                      required: true,
                                      whitespace: true,
                                      message: '請輸入姓名和內容不為空',
                                    },
                                    {
                                      type: 'string',
                                      min: 0,
                                      max: 40,
                                      message: '超過字數限制(最多為40個字)',
                                    },
                                  ]}>
                                  <Input className='form-control feedback-content-input' />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                          <div class='col-md-6'>
                            <div class='form-group row align-items-center'>
                              <label
                                class='col-sm-4 col-form-label h6 text-navy text-md-right'
                                for=''>
                                {__('電話', 'cec-plugin-stores')}*
                              </label>
                              <div class='col-sm-8'>
                                <Form.Item
                                  {...genFormItemAtrribute('Var_Tel')}
                                  className='mb-0'
                                  rules={[
                                    {
                                      type: 'string',
                                      required: true,
                                      whitespace: true,
                                      message: '請輸入電話和內容不能為空白',
                                    },
                                  ]}>
                                  <Input className='form-control feedback-content-input' />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class='row'>
                          <div class='col-12'>
                            <div class='form-group row align-items-center mb-0'>
                              <label
                                class='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('信箱', 'cec-plugin-stores')}*
                              </label>
                              <div class='col-sm-10'>
                                <Form.Item
                                  {...genFormItemAtrribute('Var_Email')}
                                  className='mb-0'
                                  rules={[
                                    {
                                      type: 'email',
                                      required: true,
                                      message: '請輸入信箱和內容不能為空白',
                                    },
                                  ]}>
                                  <Input className='form-control feedback-content-input' />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 訊息類型：客服建議、服務建議 */}
                {_.indexOf(
                  [SubjectID.CustomerService, SubjectID.Service],
                  selectedSubjectId,
                ) !== -1 && (
                  <div class='row no-gutters mx-n3 mb-4 stre'>
                    <div class='col-lg-3 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body pb-0 pt-5 p-lg-5'>
                          <div class='row mb-4'>
                            <div class='col-4 mx-auto'>
                              <img
                                class='img-contain'
                                src={ICON_MESSAGE}
                                alt='訊息類型'
                              />
                            </div>
                          </div>
                          <h5 class='h4 text-navy text-center'>
                            {__('訊息類型', 'cec-plugin-stores')}
                          </h5>
                          <p class='note text-primary text-center mb-0'>
                            {__('必填資料', 'cec-plugin-stores')}*
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class='col-lg-9 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body p-5 w-100'>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('訊息類別', 'cec-plugin-stores')}*
                            </label>
                            <div
                              className={`${
                                styles['query-types-select-wrapper']
                              } col-sm-10`}>
                              <Form.Item
                                {...genFormItemAtrribute('queryTypes_lv1')}
                                rules={[
                                  {
                                    required: queryTypesList_lv1.length > 0,
                                    message: '請選擇類別',
                                  },
                                ]}>
                                <Select
                                  dropdownClassName={
                                    styles['select-wrapper']
                                  }
                                  placeholder='Please Select'
                                  onChange={(val) => {
                                    this.formRef.current.setFields([
                                      {
                                        name: 'queryTypes_lv2',
                                        value: undefined,
                                        errors: [],
                                      },
                                      {
                                        name: 'queryTypes_lv3',
                                        value: undefined,
                                        errors: [],
                                      },
                                    ])
                                  }}>
                                  {queryTypesList_lv1.map((item) => (
                                    <Select.Option key={item.id}>
                                      {item.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                              <Form.Item
                                {...genFormItemAtrribute('queryTypes_lv2')}
                                rules={[
                                  {
                                    required: queryTypesList_lv2.length > 0,
                                    message: '請選擇類別',
                                  },
                                ]}>
                                <Select
                                  dropdownClassName={
                                    styles['select-wrapper']
                                  }
                                  placeholder='Please Select'
                                  disabled={queryTypesList_lv2.length === 0}
                                  onChange={(val) => {
                                    this.formRef.current.setFields([
                                      {
                                        name: 'queryTypes_lv3',
                                        value: undefined,
                                        errors: [],
                                      },
                                    ])
                                  }}>
                                  {queryTypesList_lv2.map((item) => (
                                    <Select.Option key={item.id}>
                                      {item.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                              <Form.Item
                                {...genFormItemAtrribute('queryTypes_lv3')}
                                rules={[
                                  {
                                    required: queryTypesList_lv3.length > 0,
                                    message: '請選擇類別',
                                  },
                                ]}>
                                <Select
                                  dropdownClassName={
                                    styles['select-wrapper']
                                  }
                                  placeholder='Please Select'
                                  disabled={
                                    queryTypesList_lv3.length === 0
                                  }>
                                  {queryTypesList_lv3.map((item) => (
                                    <Select.Option key={item.id}>
                                      {item.name}
                                    </Select.Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          </div>
                          <Form.Item noStyle shouldUpdate>
                            {() => {
                              const isOnlineShopping =
                                _.indexOf(
                                  ONLINE_SHOPPING_CODES,
                                  _.last(
                                    this.getFieldValue('queryTypes', []),
                                  ),
                                ) !== -1
                              if (!isOnlineShopping) return <Fragment />
                              return (
                                <Fragment>
                                  <div class='form-group mb-4 row align-items-center'>
                                    <div class='col-12'>
                                      <div class='form-group row align-items-center mb-0'>
                                        <label
                                          class='col-sm-2 col-form-label h6 text-navy'
                                          for=''>
                                          {__(
                                            '訂單號碼',
                                            'cec-plugin-stores',
                                          )}
                                          *
                                        </label>
                                        <div class='col-sm-10'>
                                          <Form.Item
                                            {...genFormItemAtrribute(
                                              'Var_OrderId',
                                            )}
                                            extra={
                                              <div>
                                                <a style={{ color: 'red' }}>
                                                  如果訂單已成立，請點選【
                                                  <h7
                                                    style={{
                                                      color: '#24A0F7',
                                                    }}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    onClick={(
                                                      selectoderlist,
                                                    ) => {
                                                      if (
                                                        isLogin === false
                                                      ) {
                                                        Modal.confirm({
                                                          title:
                                                            '線上購物問題，請先登入會員',
                                                          cancelText:
                                                            '知道了',
                                                          okText:
                                                            '立即登入',
                                                          onOk: () => {
                                                            // ALVIN 2023/05/05 調整CC login remark
                                                            // this.GetOcaUri()
                                                            this.GetCCUri()
                                                            if (
                                                              this.state
                                                                .LoginUrl
                                                            )
                                                              window.location.replace(
                                                                this.state
                                                                  .LoginUrl,
                                                              )
                                                          },
                                                          onCancel: () => {},
                                                        })
                                                      } else {
                                                        window.open(
                                                          'https://qa-online.uni-prosperity.com.tw/',
                                                        )
                                                      }
                                                    }}>
                                                    查詢訂單號碼
                                                  </h7>
                                                  】先登入會員
                                                  {'>'}
                                                  訂單查詢，提供訂單號碼，
                                                  以利加快處理速度。若訂單尚未成立無須填寫。
                                                </a>
                                              </div>
                                            }>
                                            <AutoComplete
                                              autoFocus
                                              defaultOpen
                                              options={_.map(
                                                orderOptions,
                                                (item) => ({
                                                  value: item.code,
                                                }),
                                              )}
                                              filterOption={(
                                                inputValue,
                                                option,
                                              ) =>
                                                option.value
                                                  .toUpperCase()
                                                  .indexOf(
                                                    inputValue.toUpperCase(),
                                                  ) !== -1
                                              }
                                              onChange={
                                                this.handleorderlist
                                              }
                                            />
                                          </Form.Item>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Fragment>
                              )
                            }}
                          </Form.Item>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('詢問對象', 'cec-plugin-stores')}*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('queryTargets')}
                                className='mb-0'
                                rules={[
                                  {
                                    required: true,
                                    message: '請選擇詢問對象',
                                  },
                                ]}
                                extra={
                                  this.state.isLoadOrderDetails &&
                                  '搜尋訂單分店...'
                                }>
                                <Cascader
                                  expandTrigger='hover'
                                  fieldNames={{
                                    value: 'id',
                                    label: 'name',
                                    children: 'items',
                                  }}
                                  options={queryTargetOptions}
                                  onChange={this.handleQueryTargetsChange}
                                />
                              </Form.Item>
                            </div>
                          </div>
                          {this.state.isShowChannelStoresField && (
                            <div class='form-group mb-4 row align-items-center'>
                              <label class='col-sm-2 col-form-label h6 text-navy'>
                                {__('通路門市', 'cec-plugin-stores')}*
                              </label>
                              <div class='col-sm-10'>
                                <Form.Item
                                  {...genFormItemAtrribute('channelStores')}
                                  className='mb-0'
                                  rules={[
                                    {
                                      required: true,
                                      message: '請選擇通路門市',
                                    },
                                  ]}>
                                  <Cascader
                                    expandTrigger='hover'
                                    fieldNames={{
                                      value: 'name',
                                      label: 'name',
                                      children: 'items',
                                    }}
                                    options={channelStoresList}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* 商品類別：新品推薦、缺貨回報、買貴回報 */}
                {_.indexOf(
                  [
                    SubjectID.NewProduct,
                    SubjectID.OutOfStock,
                    SubjectID.Expensive,
                  ],
                  selectedSubjectId,
                ) !== -1 && (
                  <div class='row no-gutters mx-n3 mb-4 stre'>
                    <div class='col-lg-3 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body pb-0 pt-5 p-lg-5'>
                          <div class='row mb-4'>
                            <div class='col-4 mx-auto'>
                              <img
                                class='img-contain'
                                src={ICON_MESSAGE}
                                alt='商品類別'
                              />
                            </div>
                          </div>
                          <h5 class='h4 text-navy text-center'>
                            {__('商品類別', 'cec-plugin-stores')}
                          </h5>
                          <p class='note text-primary text-center mb-0'>
                            {__('必填資料', 'cec-plugin-stores')}*
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class='col-lg-9 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body p-5'>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('商品類別', 'cec-plugin-stores')}*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('queryTypes_lv3')}
                                rules={[
                                  {
                                    required: true,
                                    message: '請選擇商品類別',
                                  },
                                ]}>
                                <Cascader
                                  expandTrigger='hover'
                                  fieldNames={{
                                    value: 'id',
                                    label: 'name',
                                    children: 'items',
                                  }}
                                  options={_.get(
                                    _.find(queryOptions, function(o) {
                                      return o.id == selectedSubjectId
                                    }),
                                    'items',
                                  )}
                                  onChange={(value, selectedOptions) => {
                                    const isOnlineShopping =
                                      _.indexOf(
                                        ONLINE_SHOPPING_CODES,
                                        _.last(value),
                                      ) !== -1
                                    if (
                                      isLogin === false &&
                                      isOnlineShopping
                                    ) {
                                      Modal.confirm({
                                        title: '線上購物問題，請先登入會員',
                                        cancelText: '知道了',
                                        okText: '立即登入',
                                        onOk: () => {
                                          window.location.replace(
                                            LOGIN_LINK,
                                          )
                                        },
                                        onCancel: () => {
                                          this.formRef.current.setFields([
                                            {
                                              name: ['queryTypes'],
                                              value: [],
                                              touched: true,
                                              validating: false,
                                              errors: [],
                                            },
                                          ])
                                        },
                                      })
                                    }
                                  }}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* 購物地點：客服建議、新品推薦、缺貨回報、買貴回報  */}
                <div class='row no-gutters mx-n3 mb-4 stre'>
                  <div class='col-lg-3 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body pb-0 pt-5 p-lg-5'>
                        <div class='row mb-4'>
                          <div class='col-4 mx-auto'>
                            <img
                              class='img-contain'
                              src={ICON_PLACE}
                              alt='購物地點'
                            />
                          </div>
                        </div>
                        <h5 class='h4 text-navy text-center'>
                          {__('購物地點', 'cec-plugin-stores')}
                        </h5>
                        <p class='note text-primary text-center mb-0'>
                          {__('必填資料', 'cec-plugin-stores')}*
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class='col-lg-9 px-3'>
                    <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                      <div class='card-body p-5'>
                        <div class='row'>
                          <div class='col-12'>
                            <div class='form-group row align-items-center mb-0'>
                              <label
                                class='col-sm-2 col-form-label h6 text-navy'
                                for=''>
                                {__('購物地點', 'cec-plugin-stores')}*
                              </label>
                              <div class='col-sm-10'>
                                <Form.Item
                                  {...genFormItemAtrribute('Var_Place')}
                                  className='mb-0'
                                  rules={[
                                    {
                                      type: 'string',
                                      required: true,
                                      whitespace: true,
                                      message:
                                        '請輸入購物地點和內容不能為空白',
                                    },
                                    {
                                      type: 'string',
                                      min: 0,
                                      max: 100,
                                      message:
                                        '超過字數限制(最多為100個字)',
                                    },
                                  ]}>
                                  <Input
                                    className='form-control feedback-content-input'
                                    maxLength={101}
                                  />
                                </Form.Item>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* 附加檔案：客服建議、新品推薦、缺貨回報、買貴回報  */}
                {isKiosk !== true && (
                  <div class='row no-gutters mx-n3 mb-4 stre'>
                    <div class='col-lg-3 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body pb-0 pt-5 p-lg-5'>
                          <div class='row mb-4'>
                            <div class='col-4 mx-auto'>
                              <img
                                class='img-contain'
                                src={ICON_FILE}
                                alt='附加檔案'
                              />
                            </div>
                          </div>
                          <h5 class='h4 text-navy text-center'>
                            {__('附加檔案', 'cec-plugin-stores')}
                          </h5>
                        </div>
                      </div>
                    </div>
                    <div class='col-lg-9 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body p-5'>
                          <p class='h6 mb-0 text-navy'>
                            {__(
                              '您最多可以上傳四個檔案，所有檔案大小加總不得超過4MB 可接受的格式為 png、jpg、jpeg、bmp、avi、mp4、mp3、mkv、3gp、mov',
                              'cec-plugin-stores',
                            )}
                          </p>
                          <div class='row mt-5'>
                            <Form.Item
                              {...genFormItemAtrribute('Var_Files')}
                              valuePropName='fileList'>
                              <WUpload
                                accept={fileType}
                                listType='picture-card'
                                beforeUpload={(file, fileList) => {
                                  let fileExt = null
                                  if (file.name) {
                                    fileExt = this.getFileExtension(
                                      file.name,
                                    )
                                  }
                                  if (
                                    (!file.type ||
                                      !fileType.includes(file.type)) &&
                                    !fileType.includes(fileExt)
                                  ) {
                                    this.showInfo({ title: '檔案格式錯誤' })
                                    return Promise.reject('檔案格式錯誤')
                                  }
                                  let fileSize = file.size / 1024 / 1024
                                  let currentFilesSize =
                                    _.reduce(
                                      this.getFieldValue('Var_Files'),
                                      (sum, file) => sum + file.size,
                                      0,
                                    ) /
                                    1024 /
                                    1024
                                  if (fileList.length > 4) {
                                    this.showInfo({
                                      title: '您最多可以上傳四個檔案',
                                    })
                                    return Promise.reject(
                                      '您最多可以上傳四個檔案',
                                    )
                                  }
                                  if (currentFilesSize + fileSize > 4) {
                                    this.showInfo({
                                      title: '所有檔案大小加總不得超過4MB',
                                    })
                                    return Promise.reject(
                                      '所有檔案大小加總不得超過4MB',
                                    )
                                  }
                                  return Promise.resolve()
                                }}
                                onChange={(fileList) => {
                                  if (!fileList) return
                                  this.setState({
                                    isFileUploading: fileList.some(
                                      (file) => file.status === 'uploading',
                                    ),
                                  })
                                }}>
                                {this.getFieldValue('Var_Files', [])
                                  .length < 4 && (
                                  <Button>
                                    <UploadOutlined />{' '}
                                    {__('上傳', 'cec-plugin-stores')}{' '}
                                  </Button>
                                )}
                              </WUpload>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* 回饋訊息：客服建議、服務建議 */}
                {_.indexOf(
                  [SubjectID.CustomerService, SubjectID.Service],
                  selectedSubjectId,
                ) !== -1 && (
                  <div class='row no-gutters mx-n3 mb-4 stre'>
                    <div class='col-lg-3 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body pb-0 pt-5 p-lg-5'>
                          <div class='row mb-4'>
                            <div class='col-4 mx-auto'>
                              <img
                                class='img-contain'
                                src={ICON_REPLY}
                                alt='回饋訊息'
                              />
                            </div>
                          </div>
                          <h5 class='h4 text-navy text-center'>
                            {__('回饋訊息', 'cec-plugin-stores')}
                          </h5>
                          <p class='note text-primary text-center mb-0'>
                            {__('必填資料', 'cec-plugin-stores')}*
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class='col-lg-9 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body p-5'>
                          <p class='h6 mb-0 text-navy'>
                            提醒您：為加速處理您提問的問題，請提供具體內容，若資訊不明確，將無法進一步處理及回復，敬請見諒
                          </p>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('訊息標題*', 'cec-plugin-stores')}
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('Var_Subject')}
                                className='mb-0'
                                rules={[
                                  {
                                    type: 'string',
                                    required: true,
                                    whitespace: true,
                                    message:
                                      '請輸入訊息標題和內容不能為空白',
                                  },
                                  {
                                    type: 'string',
                                    min: 0,
                                    max: 100,
                                    message: '超過字數限制(最多為100個字)',
                                  },
                                ]}>
                                <Input className='form-control feedback-content-input' />
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('留言內容', 'cec-plugin-stores')}*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('Txt_Memo')}
                                rules={[
                                  {
                                    type: 'string',
                                    required: true,
                                    whitespace: true,
                                    message:
                                      '請輸入留言內容和內容不能為空白',
                                  },
                                ]}>
                                <Input.TextArea
                                  className='form-control feedback-content-input'
                                  rows={8}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* 推薦商品資訊：新品推薦 */}
                {selectedSubjectId === SubjectID.NewProduct && (
                  <div class='row no-gutters mx-n3 mb-4 stre'>
                    <div class='col-lg-3 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body pb-0 pt-5 p-lg-5'>
                          <div class='row mb-4'>
                            <div class='col-4 mx-auto'>
                              <img
                                class='img-contain'
                                src={ICON_REPLY}
                                alt='推薦商品資訊'
                              />
                            </div>
                          </div>
                          <h5 class='h4 text-navy text-center'>
                            {__('推薦商品資訊', 'cec-plugin-stores')}
                          </h5>
                          <p class='note text-primary text-center mb-0'>
                            {__('必填資料', 'cec-plugin-stores')}*
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class='col-lg-9 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body p-5'>
                          <p class='h6 mb-0 text-navy'>
                            提醒您：為加速處理您提問的問題，請提供具體內容，若資訊不明確，將無法進一步處理及回復，敬請見諒
                          </p>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              商品名稱*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('product_name')}
                                rules={[
                                  {
                                    required: true,
                                    message: '請輸入商品名稱',
                                  },
                                ]}>
                                <Input className='form-control feedback-content-input' />
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              資訊來源*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('data_source')}
                                rules={[
                                  {
                                    required: true,
                                    message: '請輸入資訊來源',
                                  },
                                ]}>
                                <Radio.Group value='large'>
                                  <Radio.Button value='實體'>
                                    實體
                                  </Radio.Button>
                                  <Radio.Button value='網路'>
                                    網路
                                  </Radio.Button>
                                </Radio.Group>
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              商品條碼
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute(
                                  'product_barcode',
                                )}>
                                <Input className='form-control feedback-content-input' />
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              售價
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('product_price')}>
                                <Input className='form-control feedback-content-input' />
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              供應商
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('supplier')}>
                                <Input className='form-control feedback-content-input' />
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('推薦商品資訊', 'cec-plugin-stores')}*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('product_info')}
                                rules={[
                                  {
                                    required: true,
                                    message: '推薦商品資訊',
                                  },
                                ]}>
                                <Input.TextArea
                                  className='form-control feedback-content-input'
                                  rows={8}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* 回報訊息：缺貨回報 */}
                {selectedSubjectId === SubjectID.OutOfStock && (
                  <div class='row no-gutters mx-n3 mb-4 stre'>
                    <div class='col-lg-3 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body pb-0 pt-5 p-lg-5'>
                          <div class='row mb-4'>
                            <div class='col-4 mx-auto'>
                              <img
                                class='img-contain'
                                src={ICON_REPLY}
                                alt='回報訊息'
                              />
                            </div>
                          </div>
                          <h5 class='h4 text-navy text-center'>
                            {__('回報訊息', 'cec-plugin-stores')}
                          </h5>
                          <p class='note text-primary text-center mb-0'>
                            {__('必填資料', 'cec-plugin-stores')}*
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class='col-lg-9 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body p-5'>
                          <p class='h6 mb-0 text-navy'>
                            提醒您：為加速處理您提問的問題，請提供具體內容，若資訊不明確，將無法進一步處理及回復，敬請見諒
                          </p>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              商品名稱*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('Var_Subject')}
                                rules={[
                                  {
                                    required: true,
                                    message: '請輸入商品名稱',
                                  },
                                  {
                                    type: 'string',
                                    min: 0,
                                    max: 100,
                                    message: '超過字數限制(最多為100個字)',
                                  },
                                ]}>
                                <Input className='form-control feedback-content-input' />
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('缺貨說明', 'cec-plugin-stores')}*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('Txt_Memo')}
                                rules={[
                                  {
                                    required: true,
                                    message: '請輸入缺貨說明',
                                  },
                                ]}>
                                <Input.TextArea
                                  className='form-control feedback-content-input'
                                  rows={8}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* 回報資訊：買貴回報 */}
                {selectedSubjectId === SubjectID.Expensive && (
                  <div class='row no-gutters mx-n3 mb-4 stre'>
                    <div class='col-lg-3 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body pb-0 pt-5 p-lg-5'>
                          <div class='row mb-4'>
                            <div class='col-4 mx-auto'>
                              <img
                                class='img-contain'
                                src={ICON_REPLY}
                                alt='回報資訊'
                              />
                            </div>
                          </div>
                          <h5 class='h4 text-navy text-center'>
                            {__('回報資訊', 'cec-plugin-stores')}
                          </h5>
                          <p class='note text-primary text-center mb-0'>
                            {__('必填資料', 'cec-plugin-stores')}*
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class='col-lg-9 px-3'>
                      <div class='card border-0 shadow-0 d-flex justify-content-center align-items-center flex-row h-100'>
                        <div class='card-body p-5'>
                          <p class='h6 mb-0 text-navy'>
                            提醒您：為加速處理您提問的問題，請提供具體內容，若資訊不明確，將無法進一步處理及回復，敬請見諒
                          </p>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('商品名稱', 'cec-plugin-stores')}*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('product_name')}
                                rules={[
                                  {
                                    required: true,
                                    message: '請輸入商品名稱',
                                  },
                                ]}>
                                <Input className='form-control feedback-content-input' />
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('是否為促銷', 'cec-plugin-stores')}*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('onsale')}
                                rules={[
                                  {
                                    required: true,
                                    message: '請選擇是否為促銷',
                                  },
                                ]}>
                                <Radio.Group
                                  value='large'
                                  onChange={(e) => {
                                    const value = e.target.value
                                    this.option = _.get(
                                      _.find(queryOptions, function(o) {
                                        return o.id === value
                                      }),
                                      'items',
                                    )
                                    this.setState(this.option)
                                  }}>
                                  <Radio.Button value='是'>是</Radio.Button>
                                  <Radio.Button value='非'>否</Radio.Button>
                                </Radio.Group>
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('比價通路', 'cec-plugin-stores')}*
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('retailChannel')}
                                rules={[
                                  {
                                    required: true,
                                    message: '請選擇比價通路',
                                  },
                                ]}>
                                <Cascader
                                  expandTrigger='hover'
                                  fieldNames={{
                                    value: 'name',
                                    label: 'name',
                                    children: 'items',
                                  }}
                                  options={retailChannelOptions}
                                  onChange={(value, selectedOptions) => {
                                    const isOnlineShopping =
                                      _.indexOf(
                                        ONLINE_SHOPPING_CODES,
                                        _.last(value),
                                      ) !== -1
                                    if (
                                      isLogin === false &&
                                      isOnlineShopping
                                    ) {
                                      Modal.confirm({
                                        title: '線上購物問題，請先登入會員',
                                        cancelText: '知道了',
                                        okText: '立即登入',
                                        onOk: () => {
                                          window.location.replace(
                                            LOGIN_LINK,
                                          )
                                        },
                                        onCancel: () => {
                                          this.formRef.current.setFields([
                                            {
                                              name: ['queryTypes'],
                                              value: [],
                                              touched: true,
                                              validating: false,
                                              errors: [],
                                            },
                                          ])
                                        },
                                      })
                                    }
                                  }}
                                />
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row align-items-center'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('比價通路價格', 'cec-plugin-stores')}
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item
                                {...genFormItemAtrribute('product_price')}
                                rules={[
                                  {
                                    required: true,
                                    message: '請輸入比價通路價格',
                                  },
                                ]}>
                                <Input className='form-control feedback-content-input' />
                              </Form.Item>
                            </div>
                          </div>
                          <div class='form-group mb-4 row'>
                            <label
                              class='col-sm-2 col-form-label h6 text-navy'
                              for=''>
                              {__('留言內容', 'cec-plugin-stores')}
                            </label>
                            <div class='col-sm-10'>
                              <Form.Item {...genFormItemAtrribute('desc')}>
                                <Input.TextArea
                                  className='form-control feedback-content-input'
                                  rows={8}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                <div class='row justify-content-center'>
                  <div class='col-6 col-lg-3 mt-5'>
                    <a
                      class={
                        this.state.isFileUploading ||
                        !this.state.agreePersonalInfo
                          ? submitBtnDisabledCx
                          : submitBtnCx
                      }
                      role='button'
                      href='#'
                      onClick={
                        !this.state.agreePersonalInfo
                          ? (e) => e.preventDefault()
                          : this.handleFormSubmit
                      }>
                      {__('確定送出', 'cec-plugin-stores')}
                    </a>
                  </div>
                </div>
                <Modal
                  title='確定送出'
                  visible={this.state.visible}
                  onOk={() => {
                    this.submitData(this.state.info)
                    this.setState({
                      confirmLoading: true,
                    })
                  }}
                  confirmLoading={this.state.confirmLoading}
                  onCancel={() => {
                    this.setState({
                      visible: false,
                    })
                  }}>
                  請再次確認是否送出
                </Modal>
              </div>
            </section>
          </Form>
        </main>
      </Fragment>
    )
  }
}

// 編輯器
export class ContactUsEditor extends Component {
  render() {
    return (
      <div className="vu-blocks-editor">
        <div class="components-placeholder__label">
          <span class="block-editor-block-icon">
            <div class="dashicons dashicons-format-status" />
          </span>
          聯絡我們模組
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/customer-service/contact-us.js